import { startListening, setToken } from '@bonanza-social/toolkit/state';
import { apiConfig, ApiError } from '@bonanza-social/toolkit/api';
import { logError } from '@bonanza-social/toolkit/logging';
import { AsyncStorage } from '@bonanza-social/toolkit/storage';
import { prefetchImages } from '../../utils/images';
import {
  setCampaignEnded,
  setQuickRulesShown,
  fetchPrizeWallCampaign,
} from './prizeWallCampaign.slice';

// TODO: Comment out until we are ready to enable Prize Wall Campaigns
// startListening({
//   actionCreator: appSync,
//   effect: (_, { dispatch }) => {
//     dispatch(fetchPrizeWallCampaign());
//   },
// });

startListening({
  actionCreator: fetchPrizeWallCampaign.fulfilled,
  effect: ({ payload }, { dispatch }) => {
    const { tokenName, images, tokenBalance } = payload;

    dispatch(
      setToken({
        name: tokenName,
        iconSmall: images.tokenIconSmall,
        iconLarge: images.tokenIconLarge,
        balance: tokenBalance,
      }),
    );
  },
});

startListening({
  actionCreator: fetchPrizeWallCampaign.fulfilled,
  effect: async ({ payload }, { dispatch }) => {
    try {
      const { id } = payload;
      const userId = await apiConfig.getUserId();
      const quickRulesShownMapping = await AsyncStorage.getItem(
        'PRIZE_WALL_QUICK_RULES_SHOWN_MAPPING',
      );

      if (quickRulesShownMapping) {
        const mapping = JSON.parse(quickRulesShownMapping);

        dispatch(setQuickRulesShown(Boolean(mapping?.[id]?.includes(userId))));
      }
    } catch (error) {
      logError('Failed to parse quick rules shown mapping', error);
    }
  },
});

startListening({
  actionCreator: fetchPrizeWallCampaign.fulfilled,
  effect: ({ payload }) => {
    prefetchImages([
      payload.images.promotionalImage,
      payload.images.promotionalBackgroundImage,
      payload.images.quickRulesBackgroundImage,
      payload.images.winnersBackgroundImage,
      payload.images.infoBackgroundImage,
      payload.images.infoBannerImage,
      payload.images.ribbonImage,
    ]);
  },
});

startListening({
  actionCreator: fetchPrizeWallCampaign.rejected,
  effect: ({ payload }, { dispatch }) => {
    if (payload instanceof ApiError && payload.status === 404) {
      dispatch(setCampaignEnded());
    }
  },
});
